export function formatMoney(money: number) {
  return `$ ${
    Number.isFinite(+money)
      ? (Math.round(money * 100) / 100)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      : 0
  }`;
}

/**
 * Removes duplicate values from an array.
 * @param ar Array containing values. Values may be all the same or different types
 */
export const uniqueArray = <T>(ar: Array<T>): Array<T> => {
  var j: Record<string, T> = {};

  ar.forEach((v) => {
    j[`${v}::${typeof v}`] = v;
  });

  return Object.keys(j).map((v) => {
    return j[v];
  });
};

/**
 * Simple debounce function
 * @param callback callback function to be invoked after delay has passed
 * @param waitFor delay in ms
 */
export const debounce = <T extends (...args: any[]) => any>(
  callback: T,
  waitFor: number
) => {
  let timeout = 0;
  return (...args: Parameters<T>): ReturnType<T> => {
    let result: any;
    clearTimeout(timeout);
    timeout = window.setTimeout(() => {
      result = callback(...args);
    }, waitFor);
    return result;
  };
};

/**
 * Get formatted time so that it can be used in a filename
 */
export const getFileFormattedTime = () => {
  var today = new Date();
  var y = today.getFullYear();
  // JavaScript months are 0-based.
  var m = today.getMonth() + 1;
  var d = today.getDate();
  var h = today.getHours();
  var mi = today.getMinutes();
  var s = today.getSeconds();
  return `${y}-${m}-${d}-${h}-${mi}-${s}`;
};

export function cmToFt(value: number): string {
  try {
    const ft = Math.floor(+value / 12);
    const ftString = ft > 0 ? `${ft}ft.` : '';
    const inc = +value % 12;
    const incString = inc > 0 ? `${inc}in.` : '';
    return `${ftString} ${incString}`;
  } catch (e) {
    return '';
  }
}
